export default class lowlayerManager {
    constructor() {

        this.h = window.innerHeight;

        this.$localNavi = $("#l-lowlayer-nav");
        this.$localNaviList = $("#l-lowlayer-nav li");

        this.$spGnavi = $("#l-header-btn");

        this.point = this.$localNavi.offset().top-this.h; /* 動作ポイント */

        this.conf = {
            MAX : this.$localNaviList.length
        }

        this.status = {
            start : false, /* 動作が開始しているか */
            move  : true, /* 動作中か監視 */
            current : -1,
            prevCurrent:this.conf.MAX,
            listPosi : [], /* 今のポジション */
            listPrevPosi : [], /* 手前のポジション */
            resizeFlg : false,
            resizeTimer :""
        }


    }
    init(){



    }
    render(scInc){


        if(this.point<= scInc){

            if(!this.status.start){
                this.status.start = true;
                let _this = this;

                setTimeout(function () {
                    _this.status.move = false;
                },2e3);
            }

        }else{
            this.status.start = false;
        }



        if(this.status.start&&!this.status.move&&!this.status.resizeFlg&&!this.$spGnavi.hasClass("is-open")) this.loop();


    }

    loop(){


        this.status.move = true;

        let _this = this;
        let _count = 0;
        let _reset = [];
        let _m = [];



        for(let i=0; i<_this.conf.MAX; i++) {

            if(!_this.status.listPrevPosi[i]) _this.status.listPrevPosi[i]=_this.$localNaviList.innerWidth()*i;

            _m[i] = i-_this.status.current-1;
            if(_m[i]<-1) {
                _reset[i] = (_m[i]==-2)?true:false;
                _m[i] = _this.conf.MAX + _m[i];
            }

            _this.status.listPosi[i] = _this.$localNaviList.innerWidth()*_m[i];

            if(_reset[i]){
                _reset[i] = false;
                // _this.status.listPrevPosi[i] = _this.status.listPosi[i]+_this.$localNaviList.innerWidth();
                TweenMax.set(_this.$localNaviList.eq(i),{
                    x : _this.status.listPosi[i]+_this.$localNaviList.innerWidth()
                });
            }

            if(_this.conf.MAX-1===i&&_this.status.current==0){ /* 最後のが画面外に移動した場合は動作させないは動作させない */
                _reset[5] = false;
                _this.status.listPosi[5] = _this.$localNaviList.innerWidth()*4;
                TweenMax.set(_this.$localNaviList.eq(5),{
                    x : _this.status.listPosi[5]+_this.$localNaviList.innerWidth()
                });
            }

                TweenMax.to(_this.$localNaviList.eq(i),1.3,
                    {
                        x : _this.status.listPosi[i],
                        ease: Power2.easeInOut,
                        onComplete:function () {
                            _count++;


                            if(_count == _this.conf.MAX-1) {

                                setTimeout(function () {
                                    _this.status.move = false;
                                },1e3);


                            }
                            _this.status.listPrevPosi[i] = _this.status.listPosi[i];


                        }
                    }
                );





        }

        _this.status.current++;
        if(_this.status.current>_this.conf.MAX-1) _this.status.current=0;

    }

    resize(){
        this.h = window.innerHeight;

        this.point = this.$localNavi.offset().top-this.h;

        this.status.resizeFlg = false;

        let _reset = [];
        let _m = [];
        for(let i=0; i<=this.conf.MAX; i++) {

            // let _n1 = i-this.status.current,
            //     _n2 = this.status.current-i;
            //
            // this.status.listPosi[i] = (_n1>0)?this.$localNaviList.innerWidth()*_n1:this.$localNaviList.innerWidth()*_n2;

            _m[i] = i-this.status.current-1;

            if(_m[i]<-1) {
                _reset[i] = (_m[i]==-2)?true:false;
                _m[i] = this.conf.MAX + 1 + _m[i];
            }

            this.status.listPosi[i] = this.$localNaviList.innerWidth()*_m[i];


            TweenMax.set(this.$localNaviList.eq(i),{
                x : this.status.listPosi[i]
            });
        }

        let _this = this;
        clearTimeout(this.status.resizeTimer);
        this.status.resizeTimer = setTimeout(function () {
            _this.status.resizeFlg = false;
        },2e2);


    }
}